'use es6';

import PropTypes from 'prop-types';
import { memoize } from 'underscore';
import CalypsoHandleButtonWrapper from 'layout-dnd-components/DndToolbar/CalypsoHandleButtonWrapper';
import PinnedToolbar from 'layout-dnd-components/DndToolbar/PinnedToolbar';
import { buildStyleRowAction, buildDuplicateRowAction, buildDeleteRowAction } from './BaseResponsiveRowToolbar';
import { hashFunctionForNArgs } from './helpers';
import { buildStyleColumnAction, buildDuplicateColumnAction, buildDeleteColumnAction } from './BaseResponsiveColumnToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapWithCalypsoHandle = connectDragSource => ({
  handleButton
}) => {
  // Wrap styled component with connectDragSource if available
  const ref = connectDragSource ? divElement => connectDragSource(divElement) : undefined;
  return /*#__PURE__*/_jsx(CalypsoHandleButtonWrapper, {
    ref: ref,
    children: handleButton
  });
};
export const buildActionsForEmptyColumn = memoize((columnName, layoutSectionId, dispatch, bus) => {
  return [buildStyleColumnAction(columnName, layoutSectionId, dispatch, bus), buildDuplicateColumnAction(columnName, layoutSectionId, dispatch, bus), buildDeleteColumnAction(columnName, layoutSectionId, dispatch, bus)];
}, hashFunctionForNArgs(2));
export const buildActionsForEmptyRow = memoize((rowName, layoutSectionId, dispatch, bus) => {
  return [buildStyleRowAction(rowName, layoutSectionId, dispatch, bus), buildDuplicateRowAction(rowName, layoutSectionId, dispatch, bus), buildDeleteRowAction(rowName, layoutSectionId, dispatch, bus)];
}, hashFunctionForNArgs(2));
export const BaseResponsiveEmptyContainerToolbar = ({
  icon,
  style,
  actions,
  handleTooltip,
  responsiveSize,
  onDropdownOpenChange,
  connectDragSource
}) => {
  return /*#__PURE__*/_jsx(PinnedToolbar, {
    active: true,
    pinLocation: "top right",
    icon: icon,
    actions: actions,
    renderWrappedHandle: wrapWithCalypsoHandle(connectDragSource),
    onDropdownOpenChange: onDropdownOpenChange,
    className: "hs-ls-responsive-toolbar hs-ls-responsive-empty-toolbar",
    style: style,
    responsiveSize: responsiveSize,
    handleTooltip: handleTooltip
  });
};
BaseResponsiveEmptyContainerToolbar.propTypes = {
  icon: PropTypes.node.isRequired,
  style: PropTypes.object,
  actions: PropTypes.array.isRequired,
  responsiveSize: PropTypes.string.isRequired,
  handleTooltip: PropTypes.string,
  onDropdownOpenChange: PropTypes.func,
  connectDragSource: PropTypes.func
};